exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simulator__select .colors__items {\n  width: calc(100% + 16px);\n  margin: -8px;\n}\n.simulator__select .colors__item {\n  margin: 8px;\n}", ""]);

// exports
